import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {TasksModel} from '../../../tasks/models/tasks.model';

class CustomFeedbackAnswersModel {
    id: number;
    // tslint:disable-next-line:variable-name
    section_id: number;
    title: string;
    order: number;
}

class CustomFeedbackModel {
    // tslint:disable-next-line:variable-name
    section_id: number;
    // tslint:disable-next-line:variable-name
    del_id: number;
    answers: { question: CustomFeedbackAnswersModel, value: number }[];
}

@Component({
    selector: 'app-journey-list-template-feedback-progress',
    templateUrl: './list-template-feedback-progress.component.html',
    styleUrls: ['./list-template-feedback-progress.component.scss']
})
export class LearningJourneyListTemplateFeedbackProgressComponent implements OnInit {

    details: CustomFeedbackModel = null;
    title: string = null;
    description: string = null;

    @Input() disabled = false;
    @Input() for_manager = false;
    @Input() embedded = false;
    @Input() task: TasksModel = null;
    @Output() doChange: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
    }

    onChange(question, event) {
      if (question.value !== event.detail.value) {
        question.value = event.detail.value;
        this.doChange.emit(this.task.details.custom_feedback);
      }
    }
}
